<template>
  <section class="how-section">
    <div class="how-inner">
      <div class="section-eyebrow">{{ t('how.eyebrow') }}</div>
      <h2 class="section-heading">{{ t('how.heading') }}</h2>
      <p class="section-sub">{{ t('how.sub') }}</p>
      <div class="how-steps">
        <div class="how-step">
          <div class="how-step-num">1</div>
          <div class="how-step-title">{{ t('how.step1Title') }}</div>
          <div class="how-step-desc">{{ t('how.step1Desc') }}</div>
          <span class="how-step-tag">{{ t('how.step1Tag') }}</span>
        </div>
        <div class="how-step">
          <div class="how-step-num">2</div>
          <div class="how-step-title">{{ t('how.step2Title') }}</div>
          <div class="how-step-desc">{{ t('how.step2Desc') }}</div>
          <span class="how-step-tag">{{ t('how.step2Tag') }}</span>
        </div>
        <div class="how-step">
          <div class="how-step-num">3</div>
          <div class="how-step-title">{{ t('how.step3Title') }}</div>
          <div class="how-step-desc">{{ t('how.step3Desc') }}</div>
          <span class="how-step-tag">{{ t('how.step3Tag') }}</span>
        </div>
      </div>
      <div class="how-cta">
        <button class="btn-cta" @click="goToReport">{{ t('hero.ctaPrimary') }}</button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useAppStore } from '@/stores/app';
const { t } = useI18n();
const store = useAppStore();
const goToReport = () => store.setStep('oauth');
</script>
